<h2 mat-dialog-title>
  {{ bannerForm.value.id > 0 ? 'Update Banner' : 'Add Banner' }}
</h2>



<form [formGroup]="bannerForm">

  <mat-dialog-content>

    <div class="row">

      <!-- Banner Name -->
      <div class="col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Banner Name</mat-label>
          <input matInput formControlName="bannerName">


          <mat-error *ngIf="bannerForm.get('bannerName')?.touched && bannerForm.get('bannerName')?.hasError('required')">
            Banner Name is required
          </mat-error>

          <mat-error *ngIf="bannerForm.get('bannerName')?.touched && bannerForm.get('bannerName')?.hasError('minlength')">
            Banner Name must be at least 3 characters long
          </mat-error>

          <mat-error *ngIf="bannerForm.get('bannerName')?.touched && bannerForm.get('bannerName')?.hasError('maxlength')">
            Banner Name cannot exceed 100 characters
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Sort Order -->
      <div class="col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Sort Order</mat-label>
          <input matInput type="number" formControlName="sortOrder">

          <mat-error *ngIf="bannerForm.get('sortOrder')?.touched && bannerForm.get('sortOrder')?.hasError('required')">
            Sort Order is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Redirect URL -->
      <div class="col-md-12 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Redirect URL</mat-label>
          <input matInput formControlName="redirectUrl">

          <mat-error *ngIf="bannerForm.get('redirectUrl')?.touched && bannerForm.get('redirectUrl')?.hasError('pattern')">
            Please enter a valid URL (e.g. https://example.com)
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Banner Image -->
      <div class="col-md-12 mb-3">
        
        <label class="fw-bold mb-2">Banner Image</label>
          <div>
    <span class="badge bg-warning text-dark me-2">Note</span>
    <small class="text-danger fw-bold">
      Image dimensions must be exactly 1238 × 651 pixels (Max Size: 5 MB)
    </small>
  </div>
  <br>


        <input [disabled]="isEditMode"
          type="file"
          class="form-control"
          accept=".jpg,.jpeg,.png,.webp"
          (change)="onFileSelected($event)">
      </div>

      <!-- Image Preview -->
      <div class="col-md-12 mb-3" *ngIf="imagePreview">
        <img
          [src]="imagePreview"
          class="img-thumbnail img-fluid"
          style="max-height:200px;"
          alt="Banner Preview">
      </div>

      <!-- Active Checkbox -->
      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="isActive">
          Active
        </mat-checkbox>
      </div>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button
      mat-button
      type="button"
      (click)="closePopup()">
      Cancel
    </button>

    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="saveBanner()">
      Save
    </button>

  </mat-dialog-actions>

</form>
